'use client';

import styled from 'styled-components';
import { ScQuestionAnswer } from '@/components/footerStaticPages/faq/styled';
import { getCDNImageUrl } from '@/helpers/cdn';
import { ScStepsByGroup } from '@/modules/restrictions/components/StepsByGroup/styled';
import { device, typography } from '@/styles/helpers';

export const ScMissionPageContainer = styled.div`
  & .section-1 {
    position: relative;
    padding: 96px 16px 22px;
    margin-top: -96px;
    text-align: center;

    & .bg-1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: -1;
    }

    @media (${device.mobile}) {
      padding-top: 69px;
      margin-top: -69px;
    }

    & > .title {
      ${typography.headline1};
      max-width: 800px;
      color: #fff;
      text-align: center;
      text-transform: uppercase;
      margin: 0 auto 16px;

      @media (${device.mobile}) {
        ${typography.headline1mobile};
        margin-bottom: 12px;
      }
    }

    & > .description {
      ${typography.body1regular};
      max-width: 800px;
      color: #fff;
      text-align: center;
      margin: 0 auto 16px;

      @media (${device.mobile}) {
        ${typography.body2regular};
      }
    }

    & > .countdown {
      display: inline-flex;
      padding: 8px 12px;
      gap: 8px;
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      background: rgba(0, 0, 0, 0.8);
      margin: 0 auto 66px;
      text-align: start;

      @media (${device.mobile}) {
        margin-bottom: 105px;
      }
    }
  }

  & .section-2 {
    padding: 66px 16px 24px;
    background-image: url(${getCDNImageUrl('/mission/bg-2.webp')});
    background-position: top;
    background-size: cover;
  }

  & .mission-stages {
    position: relative;
    max-width: 1133px;
    margin: 0 auto;
    padding: 20px 0;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    background: linear-gradient(
      180deg,
      rgba(55, 7, 19, 0.06) 0.1%,
      rgba(55, 7, 19, 0.6) 58.06%,
      rgba(55, 7, 19, 0.18) 99.9%
    );
    box-shadow: 0 0 36px 0 rgba(211, 9, 59, 0.16);
    backdrop-filter: blur(2px);

    @media (${device.mobile}) {
      padding: 16px 0 24px;
    }
  }

  & .mission-stages-button {
    position: absolute;
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 195px;
    border-radius: 360px;
    background: rgba(255, 255, 255, 0.2);
    box-shadow:
      0 0 8px 0 rgba(0, 0, 0, 0.2),
      0 0 12px 0 rgba(0, 0, 0, 0.6);
    z-index: 2;
    border: none;
    transition: all 0.2s ease;

    &.left {
      left: 24px;
    }

    &.left i {
      transform: rotate(180deg);
    }

    &.right {
      right: 24px;
    }

    &.active {
      background: #fff;
      cursor: pointer;
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }

  & .mission-description {
    ${typography.body2regular};
    max-width: 424px;
    color: #fff;
    text-align: center;
    margin: 0 auto 16px;
  }

  & .mission-button {
    display: block;
    max-width: 248px;
    width: 100%;
    margin: 0 auto;

    @media (${device.mobile}) {
      max-width: none;
    }
  }

  & .bonuses-notice-box {
    margin-block: -16px 16px;
    width: min(480px, 100%);
    margin-inline: auto;
    position: relative;
    z-index: 5;

    &:empty {
      display: none;
      margin: 0;
    }
  }

  ${ScStepsByGroup} {
    max-width: 1088px;
    margin: 0 auto 64px;

    & .cards {
      margin: 0;
      gap: 18px;
    }

    & .card {
      padding: 24px 24px 24px 108px;
      background: linear-gradient(90deg, #1c1c1e 0%, #611128 100%);
    }

    & .image {
      left: 8px;
    }
  }

  ${ScQuestionAnswer} {
    & .question {
      background: linear-gradient(90deg, #1c1c1e 0%, #611128 100%);
    }

    & .answer-box {
      background: linear-gradient(90deg, #1c1c1e 0%, #611128 100%);
    }
  }
`;
